import Vue from 'vue'
import axios from 'axios'

window.auth = {
    
    api:{
        location: process.env.API_URL,
        refreshURL: process.env.API_URL+'/auth/refresh',
        tokenLoginURL: process.env.API_URL+'/auth/app',
        routerLoginPath: '/'
    },
    loggedIn: false,
    authType: 'web',
    storageType: 'local',
    storageName: 'my_dubline',
    refreshTimer: null,
    inactivityTimer: null,
    timerTime: 0,
    inactive: false,
    onLogoutAction: null,
    onLoginAction: null,
    
    __construct(){
        
        if(this.localStorageAvailable() == true){
            
            this.setStorageType('local');
        }
        else{
            
            this.setStorageType('cookies');
        }
    },
    
    onLoginStart(callback){
        
        this.onLoginAction = callback;
    },
    
    onLogout(callback){
        
        this.onLogoutAction = callback;
    },
    
    logout(){
        
        var storageName = this.storageName;
        
        this.emptyStorage();
        this.setLoggedIn(false);
        this.onLogoutAction();
    },
    
    setInactivityTimerTime(time){
        
        this.timerTime = time * 1000;
    },
    
    getInactivityTimerTime(){
        
        return this.timerTime;
    },
    
    authenticate(callback){
        
        this.onLoginAction();
        
        var urlString = window.location.href;
        var url = new URL(urlString);
        var state = url.searchParams.get('state');
        
        if(state == '' || state == null){
            
            var tokens = this.getTokens();
            var _this = this;
            
            if(tokens != null){
                
                //Use refresh token in attempt to get a new jwt and rt
                axios.post(this.api.refreshURL, {
                    
                    refresh_token: tokens.refresh_token
                })
                .then(response => {
                    
                    window.auth.setInactivityTimerTime(response.data.jwt_expire_time);
                    
                    _this.setTokens(response.data);
                    _this.upgrade();
                    _this.setLoggedIn(true);

                    callback(true);
                })
                .catch(e => {
                    
                    this.emptyStorage();
                    
                    callback(false);
                })
            }
            else{
                
                callback(false);
            }
        }
        else{
            
            this.appTokenLogin(callback, state);
        }
    },
    
    upgrade(){
        
        var tokens = this.getTokens();
        
        Vue.prototype.$api = window.api = axios.create({
            baseURL: this.api.location,
            timeout: 12000,
            headers: {'Authorization': 'Bearer ' + tokens.token}
        });
    },
    
    setTokens(data){
        
        var storageType = this.getStorageType();
        var j = JSON.stringify(data);
        var storageName = this.getStorageName();
        
        if(storageType === 'local'){
            
            localStorage.setItem(storageName, j);
        }
        else{
            
            this.setCookie(storageName, j, 10);
        }
        
        this.upgrade();
    },
    
    getTokens(){
        
        var storageType = this.getStorageType();
        var storageName = this.getStorageName();
        
        if(storageType === 'local'){
        
            var storage = localStorage.getItem(storageName);

            if(storage != 'undefined'){

                var data = localStorage.getItem(storageName);
                var tokens = JSON.parse(data);

                return tokens;
            }
        }
        else{
            
            var data = this.getCookie(storageName);
            
            if(data != ''){
                
                var tokens = JSON.parse(data);
                
                return tokens;
            }
        }
        
        return null;
    },

    startRefreshTimer(wait){
        
        if(this.inactive != true){
        
            var seconds = (wait * 1000);

            var _this = this;

            this.refreshTimer = setTimeout(function(){

                var tokens = _this.getTokens();

                if(tokens != null){

                    axios.post(_this.api.refreshURL, {

                        refresh_token: tokens.refresh_token
                    })
                    .then(response => {
                        
                        console.log('refresh');
                        
                        window.auth.setInactivityTimerTime(response.data.jwt_expire_time);

                        _this.setTokens(response.data);
                        _this.upgrade();
                        _this.setLoggedIn(true);
                    })
                    .catch(e => {
                        
                        _this.logout();
                    })
                }
            }, seconds);
        }
        else{
            
            alert('Sessie verlopen, u wordt uitgelogd.');
            
            this.logout();
            
            console.log('refresh:logout');
        }
    },
    
    setLoggedIn(b){
        
        if(b === true){
            
            //Track actions
            document.onmousemove = this.resetInactivityTimer;
            document.onkeypress = this.resetInactivityTimer;
            document.ontouchstart = this.resetInactivityTimer;
            
            var tokens = this.getTokens();
            this.startRefreshTimer(tokens.jwt_expire_time);
        }
        
        this.loggedIn = b;
    },
    
    isLoggedIn(){
        
        return this.loggedIn;
    },
    
    getLoginPath(){
        
        return this.api.routerLoginPath;
    },
    
    appTokenLogin(callback, state){
        
        axios.post(this.api.tokenLoginURL, {

            sessionToken: state
        })
        .then(response => {

            this.setTokens(response.data);
            this.upgrade();
            this.setLoggedIn(true);

            callback(true);
        })
        .catch(e => {
            
            this.emptyStorage();
            
            callback(false);
        })
    },
    
    setCookie(cname, cvalue, exdays) {
        
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = 'expires='+ d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    },
    
    getCookie(cname) {
        
        var name = cname + '=';
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        
        for(var i = 0; i <ca.length; i++) {
            
            var c = ca[i];
            
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        
        return '';
    },
    
    deleteCookie(name){
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },
    
    getStorageName(){
        
        return this.storageName;
    },
    
    setStorageType(type){
        
        this.storageType = type;
    },
    
    getStorageType(){
        
        return this.storageType;
    },
    
    localStorageAvailable(){
        
        var test = 'test';
        
        try{
            
            localStorage.setItem(test, test);
            localStorage.removeItem(test);
            
            return true;
        } 
        catch(e){
            
            return false;
        }
    },
    
    emptyStorage(){
        
        var storageName = this.getStorageName();
        
        if(this.localStorageAvailable() == true){

            localStorage.removeItem(storageName);
        }
        else{

            this.deleteCookie(storageName);
        }  
    },
    
    resetInactivityTimer(){
        
        window.auth.inactive = false;
        clearTimeout(this.inactivityTimer);
        
        var _this = this;
        var wait = window.auth.getInactivityTimerTime();
        
        if(wait != 0){
            
            this.inactivityTimer = setTimeout(function(){

                console.log('Inactivity detected');
                window.auth.inactive = true;
            }, wait);
        }
    },
};

auth.__construct();

Vue.prototype.$api = window.api = axios.create({
    baseURL: auth.api.location,
    timeout: 12000
});

Vue.prototype.$auth = window.auth;


// WEBPACK FOOTER //
// ./src/assets/js/libs/auth.js